<template>
    <v-container grid-list-xs>
        <v-layout column v-if="tour">
            <v-card class="mx-auto" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                <v-img
                :src="require(`../../public/img/img/destination_${tour.image}_ln.jpg`)"
                ></v-img>
                <v-card-title v-text="tour.title"></v-card-title>
                <v-card-subtitle v-if="tour.kind==='zanzibar'" v-text="tour.duration"></v-card-subtitle>
                <v-card-text v-html="tour.description">
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import firebase from '../configFirebase.js'
export default {
    props:{
        tourProp:{
            type:Object,
        }
    },
    data(){
        return{
            tour:undefined
        }
    },
    mounted(){
        if(this.tourProp){
            this.tour = this.tourProp
        }else{
            const id = this.$route.params.id
            firebase.db.doc(`travels/${id}`).get()
            .then((doc) => {
                if (doc.exists) {
                    this.tour = doc.data();
                    console.log("Document found!");
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch((error) => {
            console.log("Error getting document:", error);
        });
        }
    }
}
</script>